import qs from 'qs';
import { network } from 'services/network';

import { QueryParams } from 'api/queries/getTagsPerContract.query';

export const getTagsPerContract = ({ contractId }: QueryParams) => {
    const querystring = qs.stringify({ contractId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getTagsPerContract${querystring}`;
    return network.get(url).then((response) => {
        return response.data;
    });
};
